import { render } from "./CreateRecord.vue?vue&type=template&id=7878e3fd&scoped=true"
import script from "./CreateRecord.vue?vue&type=script&lang=js"
export * from "./CreateRecord.vue?vue&type=script&lang=js"

import "./CreateRecord.vue?vue&type=style&index=0&id=7878e3fd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7878e3fd"]])

export default __exports__